export const initAssignedQuestion = {
    singleQuestionsList: [],
    searchBlocksList: [],
};
